import React, { useEffect, useState, useMemo } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Button, Row, Col } from 'reactstrap'

import TaskCheckList from './TaskCheckList'
import TaskForm from './TaskForm'

import {
  saveTaskForActivity,
  getTask,
  setTodayMeeting,
  getAssignedTasks,
  getDueDateTask,
  resetAllData,
  editTaskData,
  createTasks,
} from './Redux/taskActions'
import { updateAttentionTo } from '../ReferralReport/Redux/referralReportActions'
import { setActivityInactive, updateActivity } from '../ClickToCall/Redux/clickToCallActions'
import { closeModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { updateCustomerLogistics } from '../CustomerLogistics/redux/customerLogisticsActions'
import { LOGISTICS } from '../../constants/divisions'
import { SHIPPERS } from '../../constants/contactCategory'
import { ACCOUNT_STATUS, PENDING_STATUS, PROSPECT_STATUS } from '../../constants/statuses.js'
import moment from 'moment'

const Task = ({
  isModal,
  isEdit,
  contactIdTask,
  customAssigned,
  customDueDate,
  referralIdToUpdate,
  saveTaskForActivity,
  isBatchCreation,
  taskId,
  isComplete,
  closeModal,
  dataFromActivityWhenSendEmail,
  setTodayMeeting,
  dataFromActivity,
  customOnSaveTask,
  customData,
  assignCallback,
  updateCustomerLogistics,
  contact,
  divisionId,
  isLogisticsCustomerProspect,
  isLogisticsProspectOrAccountCustomer,
  isDashboardAction,
  isLogisticsCustomerTaskActionFromDashboard,
  isRfp,
  isMfp,
  isCreditApp,
  isOnlineForm,
  isAssignWithTaskDisabled,
}) => {
  const activityIdResult = dataFromActivity
    ? dataFromActivity.activityId
    : dataFromActivityWhenSendEmail
    ? dataFromActivityWhenSendEmail.activityId
    : null

  const dispatch = useDispatch()

  const { taskData } = useSelector((state) => ({
    taskData: state.Task.data,
  }))

  const [isTaskAssignedState, setIsTaskAssignedState] = useState(false)
  const [isRfpCustomer, setIsRfpCustomer] = useState(false)
  const [isMfpCustomer, setIsMfpCustomer] = useState(false)
  const [isCreditAppCustomer, setIsCreditAppCustomer] = useState(false)
  const [isOnlineFormCustomer, setIsOnlineFormCustomer] = useState(false)

  const displayButton = useMemo(() => {
    return {
      rfp: (isLogisticsCustomerProspect && !isDashboardAction) || isLogisticsCustomerTaskActionFromDashboard,
      mfp: (isLogisticsProspectOrAccountCustomer && !isDashboardAction) || isLogisticsCustomerTaskActionFromDashboard,
      creditApp:
        (isLogisticsProspectOrAccountCustomer && !isDashboardAction) || isLogisticsCustomerTaskActionFromDashboard,
      onlineForm:
        (isLogisticsProspectOrAccountCustomer && !isDashboardAction) || isLogisticsCustomerTaskActionFromDashboard,
    }
  }, [
    isDashboardAction,
    isLogisticsCustomerProspect,
    isLogisticsCustomerTaskActionFromDashboard,
    isLogisticsProspectOrAccountCustomer,
  ])

  useEffect(() => {
    setIsRfpCustomer(() => {
      if (isLogisticsCustomerTaskActionFromDashboard) {
        return isRfp
      } else {
        return contact.isRfp
      }
    })
  }, [contact.isRfp, isLogisticsCustomerTaskActionFromDashboard, isRfp])

  useEffect(() => {
    setIsMfpCustomer(() => {
      if (isLogisticsCustomerTaskActionFromDashboard) {
        return isMfp
      } else {
        return contact.isMfp
      }
    })
  }, [contact.isMfp, isLogisticsCustomerTaskActionFromDashboard, isMfp])

  useEffect(() => {
    setIsCreditAppCustomer(() => {
      if (isLogisticsCustomerTaskActionFromDashboard) {
        return isCreditApp
      } else {
        return contact.isCreditApp
      }
    })
  }, [contact.isCreditApp, isLogisticsCustomerTaskActionFromDashboard, isCreditApp])

  useEffect(() => {
    setIsOnlineFormCustomer(() => {
      if (isLogisticsCustomerTaskActionFromDashboard) {
        return isOnlineForm
      } else {
        return contact.isOnlineForm
      }
    })
  }, [contact.isOnlineForm, isLogisticsCustomerTaskActionFromDashboard, isOnlineForm])

  useEffect(() => {
    if (customDueDate) {
      dispatch(editTaskData('dueDate', customDueDate))
    }
    if (taskId) {
      getTask(taskId)
    }
    if (dataFromActivity || dataFromActivityWhenSendEmail) {
      const selectedActivityType =
        (dataFromActivity && dataFromActivity.selectedActivityType) ||
        (dataFromActivityWhenSendEmail && dataFromActivityWhenSendEmail.selectedActivityType)
      dispatch(editTaskData('selectedActivityType', selectedActivityType))
    }

    if (!isBatchCreation) {
      dispatch(getAssignedTasks(contactIdTask))
      dispatch(getDueDateTask())
    }
    return () => {
      if (!isBatchCreation) {
        dispatch(resetAllData())
        dispatch(setTodayMeeting({}))
      }
    }
  }, [])

  const handleAssignCallback = (isSuccess) => {
    if (assignCallback && typeof assignCallback === 'function') {
      assignCallback(isSuccess)
    }
  }

  const handleUpdateCustomerLogistics = () => {
    const shouldUpdateRfp =
      (isLogisticsCustomerTaskActionFromDashboard && isRfp != isRfpCustomer) ||
      (isLogisticsCustomerProspect && isRfpCustomer != contact.isRfp && !isDashboardAction)

    const shouldUpdateMfp =
      (isLogisticsCustomerTaskActionFromDashboard && isMfp != isMfpCustomer) ||
      (isLogisticsProspectOrAccountCustomer && isMfpCustomer != contact.isMfp && !isDashboardAction)

    const shouldUpdateCreditApp =
      (isLogisticsCustomerTaskActionFromDashboard && isCreditApp != isCreditAppCustomer) ||
      (isLogisticsProspectOrAccountCustomer && isCreditAppCustomer != contact.isCreditApp && !isDashboardAction)

    const shouldUpdateOnlineForm =
      (isLogisticsCustomerTaskActionFromDashboard && isOnlineForm != isOnlineFormCustomer) ||
      (isLogisticsProspectOrAccountCustomer && isOnlineFormCustomer != contact.isOnlineForm && !isDashboardAction)

    if (shouldUpdateRfp || shouldUpdateMfp || shouldUpdateCreditApp || shouldUpdateOnlineForm) {
      const customerId = isDashboardAction ? contactIdTask : contact.id
      const data = {
        isCustomerUpdateOnly: true,
        rfpDate: isRfpCustomer ? moment().format('YYYY-MM-DD') : null,
        mfpDate: isMfpCustomer ? moment().format('YYYY-MM-DD') : null,
        creditAppDate: isCreditAppCustomer ? moment().format('YYYY-MM-DD') : null,
        onlineFormDate: isOnlineFormCustomer ? moment().format('YYYY-MM-DD') : null,
        isRfp: isRfpCustomer,
        isMfp: isMfpCustomer,
        isCreditApp: isCreditAppCustomer,
        isOnlineForm: isOnlineFormCustomer,
      }

      updateCustomerLogistics(customerId, divisionId, data)
    }
  }

  const getBody = () => {
    return (
      <>
        <TaskCheckList isComplete={isComplete} />
        <div className='mt-5'>
          <TaskForm
            displayButton={displayButton}
            isRfpCustomer={isRfpCustomer}
            toggleIsRfpCustomer={() => setIsRfpCustomer((prev) => !prev)}
            isMfpCustomer={isMfpCustomer}
            toggleIsMfpCustomer={() => setIsMfpCustomer((prev) => !prev)}
            isCreditAppCustomer={isCreditAppCustomer}
            toggleIsCreditAppCustomer={() => setIsCreditAppCustomer((prev) => !prev)}
            isOnlineFormCustomer={isOnlineFormCustomer}
            toggleIsOnlineFormCustomer={() => setIsOnlineFormCustomer((prev) => !prev)}
            isBatchCreation={isBatchCreation}
            customData={customData}
            isEdit={isEdit}
            contactIdTask={contactIdTask}
            dataFromActivityWhenSendEmail={dataFromActivityWhenSendEmail}
            selectedNextStep={dataFromActivity?.selectedNextStep || dataFromActivityWhenSendEmail?.selectedNextStep}
            setIsTaskAssignedState={setIsTaskAssignedState}
            taskIdEdit={taskId}
            descriptionFromActivity={dataFromActivity?.description || dataFromActivityWhenSendEmail?.description}
            customAssigned={customAssigned}
          />
        </div>
        {isTaskAssignedState && (
          <Row className='mt-3'>
            <Col className='text-right'>
              <span className='text-danger'>This user already has task assigned for this contact</span>
            </Col>
          </Row>
        )}
        <Row className='mt-3'>
          <Col className='text-right'>
            <Button
              disabled={isTaskAssignedState || isAssignWithTaskDisabled}
              className={'btn btn-gold mr-3'}
              onClick={() => {
                if (referralIdToUpdate) {
                  dispatch(updateAttentionTo(referralIdToUpdate, taskData.assigned, customAssigned, contactIdTask))
                }

                if (customOnSaveTask) {
                  customOnSaveTask()
                }

                if (activityIdResult) {
                  dispatch(updateActivity(activityIdResult, { notes: taskData.description }))
                }

                if (isBatchCreation) {
                  handleAssignCallback(true)
                } else {
                  saveTaskForActivity(taskId, contactIdTask, activityIdResult)
                }

                handleUpdateCustomerLogistics()
              }}
            >
              {isComplete ? 'Complete' : 'Ok'}
            </Button>

            <Button
              className={'btn btn-gold'}
              onClick={() => {
                handleAssignCallback(false)

                if (activityIdResult) {
                  dispatch(setActivityInactive(activityIdResult))
                }
                closeModal('task_modal')
              }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </>
    )
  }
  if (!isModal) {
    return getBody()
  }
  return (
    <>
      {/* <CustomModal
        isOpen={isModalToggle}
        toggle={toggleModal}
        headerText={`${isComplete ? "Complete" : "Edit"} Task ${contactName}`}
        big
        backdrop={false}
      > */}
      {getBody()}
      {/* </CustomModal> */}
    </>
  )
}

Task.propTypes = {
  isModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  isModalToggle: PropTypes.bool,
  contactName: PropTypes.string,
  saveTaskForActivity: PropTypes.func.isRequired,
  taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  isComplete: PropTypes.bool,
  isAssignWithTaskDisabled: PropTypes.bool,
}

Task.defaultProps = {
  isModal: true,
  isModalToggle: false,
  toggleModal: () => {},
  contactName: '',
  taskId: false,
  isComplete: false,
  isAssignWithTaskDisabled: false,
}

const mapStateToProps = (state) => {
  return {
    contactName: state.Task.contactName,
    contact: state.contacts.contact,
    divisionId: state.auth.user.division_id,
    isLogisticsCustomerProspect:
      state.auth.user.division_id === LOGISTICS &&
      state.contacts.contact.contactCategory === SHIPPERS &&
      state.contacts.contact.contactDivisionData.statusId == PROSPECT_STATUS,
    isLogisticsProspectOrAccountCustomer:
      state.auth.user.division_id === LOGISTICS &&
      state.contacts.contact.contactCategory === SHIPPERS &&
      [PROSPECT_STATUS, PENDING_STATUS, ACCOUNT_STATUS].includes(state.contacts.contact.contactDivisionData.statusId),
  }
}

export default connect(mapStateToProps, {
  saveTaskForActivity,
  createTasks,
  closeModal,
  setTodayMeeting,
  updateCustomerLogistics,
})(Task)
